module.exports = __webpack_public_path__ + "5acd8b0ca6878f759e47791879751c43.svg";